<script setup lang="ts">
  import { useGoogleAnalytics } from '@/shared/composables'
  import { BaseButton } from '@qic/ui-components'
  const gaService = useGoogleAnalytics()
</script>

<template>
  <div class="success-airalo-banner-container">
    <div class="success-airalo-banner">
      <div class="success-airalo-banner__wrapper">
        <div class="success-airalo-banner__wrapper-inner">
          <div class="success-airalo-banner__header">
            <div class="success-airalo-banner__header-content">
              <h3 class="success-airalo-banner__header-title">
                {{ $t('travel.success_screen.airalo.header') }}
              </h3>
              <p class="success-airalo-banner__header-description">
                {{ $t('travel.success_screen.airalo.desc') }}
              </p>
            </div>
            <div class="success-airalo-banner__logo">
              <img src="@/shared/assets/images/airalo-icon.svg" alt="airalo-logo" />
            </div>
          </div>
          <div class="success-airalo-banner__dots">
            <div v-for="i in 6" :key="i" class="success-airalo-banner__dot"></div>
          </div>
          <div class="success-airalo-banner__inner">
            <div class="success-airalo-banner__list">
              <p class="success-airalo-banner__list-title">
                {{ $t('travel.success_screen.airalo.list.title') }}
              </p>
              <ul class="success-airalo-banner__list-items">
                <li class="success-airalo-banner__list-item">
                  {{ $t('travel.success_screen.airalo.list.element_1') }}
                </li>
                <li class="success-airalo-banner__list-item">
                  {{ $t('travel.success_screen.airalo.list.element_2') }}
                </li>
                <li class="success-airalo-banner__list-item">
                  {{ $t('travel.success_screen.airalo.list.element_3') }}
                </li>
              </ul>
            </div>
            <a
              href="https://airalo.pxf.io/c/6486378/3245454/15608?p.code=QIC"
              target="_blank"
              @click="gaService.sendAiraloDiscountBanner"
            >
              <BaseButton class="success-airalo-banner__button" icon="none" medium full>
                {{ $t('travel.success_screen.airalo.button.text') }}
              </BaseButton>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @use './SuccessAiraloBanner';
</style>
